export default __webpack_public_path__ + "static/media/Group 8632.89228f55.png";